
import { contentfulClient } from './contentfulClient';

export async function findAppropriateContentType(contentName: string): Promise<string> {
  try {
    const contentTypes = await contentfulClient.getContentTypes();
    
    // Try to find a content type that matches the given name
    const matchingContentType = contentTypes.items.find(type => 
      type.name.toLowerCase().includes(contentName.toLowerCase()) || 
      type.sys.id.toLowerCase().includes(contentName.toLowerCase())
    );
    
    // Use the first content type as fallback
    return matchingContentType ? 
      matchingContentType.sys.id : 
      (contentTypes.items.length > 0 ? contentTypes.items[0].sys.id : contentName);
  } catch (error) {
    console.error(`Error finding content type for "${contentName}":`, error);
    return contentName;
  }
}

export async function getAvailableContentTypes() {
  try {
    const contentTypes = await contentfulClient.getContentTypes();
    return contentTypes.items.map(type => ({
      id: type.sys.id,
      name: type.name
    }));
  } catch (error) {
    console.error('Error fetching available content types:', error);
    return [];
  }
}
